module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/21bf6c1431c5ebadf613ca56307b3e7b.png";